<template>
  <v-container fill-height v-if="comments && comments.length === 0">
    <v-layout>
      <v-card-text class="text-lg-center">
        <h2 class="font-weight-light">No milestones recorded yet</h2>
      </v-card-text>
    </v-layout>
  </v-container>
  <v-timeline v-else>
    <v-timeline-item
            v-for="(item, index) in sortedTimeline"
            :key="index"
            color="secondary"
            small
            left>
      <template v-slot:opposite>
        <span>{{ item.date }}</span>
      </template>
      <v-card class="elevation-2">
        <v-card-text>
          {{ item.text }}
        </v-card-text>
      </v-card>
    </v-timeline-item>
  </v-timeline>
</template>

<script>
  export default {
    name: "CommentPOG",

    props: {
      comments: Array
    },

    computed: {
      sortedTimeline () {
        if (this.comments) {
          let sorted = [...this.comments];
          sorted.sort((a, b) => {
            let d1 = new Date(b.date);
            let d2 = new Date(a.date);
            return d2 - d1
          });
          return sorted
        } else {
          return []
        }
      }
    }
  }
</script>

<style scoped>

</style>
